export { default as getMaxFooterHeight } from './getMaxFooterHeight'

export type { MaxFooterHeight } from './getMaxFooterHeight'
